import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { retry, catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebApisService {

  private baseUrl;
  constructor(private http: HttpClient) { 
    this.baseUrl = environment.baseUrl;
  }

  get<T>(url: string) {
    return this.http.get<T>(this.baseUrl + url)
      .pipe(
        catchError(this.handleError)
      )
  }

  getV2<T>(url: string) {
    return this.http.get<T>(`https://api.alphatrend.ai/v2` + url)
      .pipe(
        catchError(this.handleError)
      )
  }

  post<T>(url: string, dto: T) {
    return this.http.post<T>(this.baseUrl + url, dto)
      .pipe( // retry a failed request up to 3 times
        catchError(this.handleError) // then handle the error
      );
  }

  delete<T>(url: string, dto) {
    return this.http.delete<T>(this.baseUrl + url)
      .pipe( // retry a failed request up to 3 times
        catchError(this.handleError) // then handle the error
      );
  }

  put<T>(url: string, dto: T) {
    return this.http.put<T>(this.baseUrl + url, dto)
      .pipe( // retry a failed request up to 3 times
        catchError(this.handleError) // then handle the error
      );
  }

  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(error);
  }
}
